/**
 * Normalize `initStageReport` response `{ game: { stages } }` into an assignment shape.
 * Stages have been removed — the puzzle is the whole game now, so only `puzzle_id` matters.
 */
export function gameFromInitStageReport(initResult) {
  const g = initResult?.game;
  if (!g || typeof g !== 'object') return null;
  const stages = g.stages ?? g;
  if (!stages || typeof stages !== 'object') return null;
  return {
    id: g.id ?? stages.id ?? null,
    puzzle_id: stages.puzzle_id != null ? Number(stages.puzzle_id) : null,
  };
}

export function applyGameAssignmentToUserData(userData, game) {
  if (!userData || !game) return userData;
  const puzzleId = game.puzzle_id ?? userData.puzzle_id ?? userData.puzzleid ?? null;
  return {
    ...userData,
    puzzle_id: puzzleId,
    puzzleid: puzzleId,
    gameStages: game,
  };
}
